import {DetailsList, IconButton, PrimaryButton} from "@fluentui/react";
import * as React from "react";
import {useContext, useEffect, useState} from "react";
import {useOutletContext, useParams} from 'react-router-dom';
import {SelectionMode} from "@fluentui/react";
import AuthContext from "../../Services/AuthContext";
import AddVentureTemplate from "../../Panel/VentureTemplate/AddVentureTemplate";

function VentureTemplate() {
    const [user] = useContext(AuthContext);
    const {actions} = useOutletContext();
    const [templates, setTemplates] = useState([]);
    const [refresh, setRefresh] = useState(0);
    const params = useParams();
    useEffect(() => {
        const abortController = new AbortController();
        async function fetchData() {
            await fetch(`/api/venture/${params.id}/template`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    if (data[0].id !== null) {
                        setTemplates(data);
                    } else {
                        setTemplates([]);
                    }
                })
                .catch(err => { console.log(err) })
        }
        fetchData();
        return () => abortController.abort();
    }, [params, refresh, user.token]);
    useEffect(() => {
        actions([
            {
                key: 'addTemplate',
                text: 'Dodaj',
                iconProps: { iconName: 'Add' },
                onClick: () => setAddTemplate(params.id)
            }
        ]);
        return actions;
    }, []);

    const [addTemplate, setAddTemplate] = useState(false);

    const deleteTemplate = (id) => {
        fetch(`/api/venture/${params.id}/template/${id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { setRefresh(refresh + 1) })
            .catch(err => { console.log(err) })
    }

    const columns = [
        {
            key: 'type',
            name: 'Wzór',
            ariaLabel: 'Wzór dokumentu',
            fieldName: 'type',
            minWidth: 200,
            isRowHeader: true,
            isResizable: true,
            onRender: (item) => (<a href={`/api/public/uploaded/${item.filename}`} target={'_blank'}><PrimaryButton text={item.type} /></a>)
        },
        {
            key: 'processor',
            name: 'Processor',
            ariaLabel: 'Sposób translacji',
            fieldName: 'processor',
            minWidth: 200,
            isResizable: false,
        },
        {
            key: 'uploaded',
            name: 'Dodano',
            ariaLabel: 'Data dodania wzoru dokumentu',
            fieldName: 'uploaded',
            minWidth: 120,
            isResizable: false
        },
        {
            key: 'id',
            name: 'Akcje',
            ariaLabel: 'Akcje',
            minWidth: 120,
            onRender: (item) => (item.active ? <IconButton iconProps={ {iconName: 'trash' }} title='Usuń' onClick={() => deleteTemplate(item.id)}/> : <span>Nieaktywny</span>)
        }
    ];

    return (
        <>
            <DetailsList items={templates} columns={columns} selectionMode={SelectionMode.none}/>
            <AddVentureTemplate add={addTemplate} dismissPanel={() => setAddTemplate(false)} onSuccess={() => setRefresh(refresh + 1)}/>
        </>
    );
}

export default VentureTemplate;